import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { categoryIcons } from "../DataEstate/DataEstateDrives";
import "./DataTagCategoryFilters.scss";
import { formatCount } from "../DataTagConstants";

const categoryNames = {
  PERSONAL: "Personal",
  MARKETING: "Marketing",
  FINANCIAL: "Financial",
  ORGANIZATIONAL: "Organizational",
  MEDICAL: "Medical",
  API: "API",
  NO_SENSITIVITY: "No Sensitivity",
  OTHER: "Other",
  NOT_PROCESSED: "Not Processed",
};

function DataTagCategoryFilters({ value = [], onChange, loc }) {
  const summaryDataRaw = useSelector(
    (state) => state.dataTagReducer.categoryCardData
  );
  const [selected, setSelected] = useState(value || []);

  useEffect(() => {
    setSelected(value);
  }, [value]);

  const toggleSelection = (key) => {
    const newSelected = selected.includes(key)
      ? selected.filter((x) => x !== key)
      : [...selected, key];
    setSelected(newSelected);
    onChange?.(newSelected);
  };

  return (
    <div className="DataTagCategoryFiltersContainer">
      {summaryDataRaw.map((fil) => {
        const isActive = selected.includes(fil["DataTagSensitivity.finalType"]);
        return (
          <div
            className="DataTagCategoryFilters"
            onClick={() => toggleSelection(fil["DataTagSensitivity.finalType"])}
          >
            <div
              title={
                loc !== "data-estate-drives"
                  ? `${categoryNames[fil["DataTagSensitivity.finalType"]]}: ${
                      fil["DataTagSensitivity.count"]
                    }`
                  : `${categoryNames[fil["DataTagSensitivity.finalType"]]}`
              }
            >
              <img
                className={
                  isActive
                    ? "data-tag-category-img isActive"
                    : "data-tag-category-img"
                }
                src={categoryIcons[fil["DataTagSensitivity.finalType"]]}
              />
            </div>
            {loc !== "data-estate-drives" && (
              <div className="data-tag-category-count">
                {formatCount(fil["DataTagSensitivity.count"])}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default DataTagCategoryFilters;
